import { CheckCircleIcon as HeroCheckCircleIcon } from '@heroicons/react/24/solid';
export const CheckCircleIcon = HeroCheckCircleIcon;
